module.exports = __webpack_public_path__ + "static/images/avater.5fb4c51.jpg";